/* stylelint-disable selector-id-pattern, selector-class-pattern */
import { Autocomplete } from '@carvana/showroom-autocomplete';
import styled from 'styled-components';

export const StyledAutocompleteStreet = styled(Autocomplete)`
  .search__magnifyIcon {
    display: none !important;
  }

  .standard-input {
    position: relative !important;
  }

  button[aria-label='Clear Search'] {
    display: none !important;
  }

  div[role='listbox'] {
    position: absolute !important;
  }

  svg {
    position: absolute !important;
    top: 10px !important;
    right: 10px !important;
    width: 15px !important;
    height: 15px !important;
    color: #2f9e44 !important;
  }

  .show-error-icon {
    border-color: #e03131 !important;

    :focus {
      border: 1px solid #e03131 !important;
    }

    ~ label {
      color: #e03131 !important;
    }

    ~ svg {
      color: #e03131 !important;
    }
  }

  #homeStreet {
    height: 60px !important;
    ~ svg {
      color: #2f9e44 !important;
    }
  }

  #coStreet {
    height: 60px !important;
    ~ svg {
      color: #2f9e44 !important;
      width: 20px !important;
      height: 20px !important;
      top: 8px !important;
      right: 4px !important;
    }

    font-size: 16px !important;

    :disabled {
      color: #aab1c7 !important;
      font-weight: 390 !important;
      background: #fff !important;
    }
  }

  div {
    height: initial !important;
  }

  .input__caption {
    margin: 5px 0 3px !important;
    font-size: 12px !important;
    font-weight: 400 !important;

    div > div {
      color: #e03131 !important;
      display: ${props => (props.hideErrorMessage ? 'none' : 'block')} !important;
    }
  }

  .is-expanded {
    input {
      border-bottom-right-radius: 3px !important;
      border-bottom-left-radius: 3px !important;
    }
  }

  display: flex !important;
  position: relative !important;
  height: initial !important;

  input:disabled {
    ~ label {
      color: #d9dde9 !important;
    }
  }
  margin-bottom: 8px;
`;

export const Row = styled.div`
  min-height: 56px;
  width: 100%;
`;

export const SingleLineWrapper = styled.div`
  display: flex;
  width: 100%;
  position: relative;
  flex-direction: column;
  align-items: flex-start;

  @media (min-width: ${props => props.theme.breakpoints.values.md}px) {
    justify-content: space-between;
    flex-direction: row;
  }
`;

export const StateAndZipWrapper = styled.div`
  display: flex;
  width: 100%;
  position: relative;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;

  @media (min-width: ${props => props.theme.breakpoints.values.md}px) {
    display: contents;
  }
`;

export const SingleLineWrapperRowLeft = styled(Row)`
  @media (min-width: ${props => props.theme.breakpoints.values.md}px) {
    width: 30rem;
    padding-right: 0.5rem;
  }
`;

export const SingleLineWrapperRowMiddle = styled(Row)`
  @media (min-width: ${props => props.theme.breakpoints.values.xs}px) {
    min-width: 5rem;
    padding-right: 0.5rem;
    justify-content: space-between;
    align-items: flex-start;
    position: relative;
    flex-direction: row;
  }

  @media (min-width: ${props => props.theme.breakpoints.values.md}px) {
    width: 15rem;
    padding-right: 0.5rem;
  }
`;

export const SingleLineWrapperRowRight = styled(Row)`
  @media (min-width: ${props => props.theme.breakpoints.values.xs}px) {
    min-width: 10rem;
    max-width: 20rem;
    justify-content: space-between;
    align-items: flex-start;
    position: relative;
    flex-direction: row;
  }

  @media (min-width: ${props => props.theme.breakpoints.values.md}px) {
    width: 20rem;
    justify-content: unset;
    align-items: unset;
    position: unset;
    flex-direction: unset;
  }
`;
